export const formatAsList = (array: string[], prefix: string): string => {
  try {
    // Our current TS types don't support the Intl.ListFormat
    // @ts-ignore-next-line
    const formatter = new Intl.ListFormat('en');
    return `${prefix}${formatter.format(array)}`;
  } catch {
    return `${prefix}${array.join(', ')}`;
  }
};
